import { NOTIFICATION_TYPES, OptimizelyUserContext } from '@optimizely/optimizely-sdk';
import { includes, kebabCase } from 'lodash';
import { optimizelyFeatureDecision } from 'store/ui/uiActions';
import { OptimizelyFeatureDecision } from 'types/events';
import { OptimizelyClientType } from './optimizely.types';

export interface OptimizelyDecisionNotificationPayload {
  flagKey: string;
  ruleKey: string;
  variationKey: string;
  enabled: boolean;
}

export function registerOptimizelyExperimentTracker({
  optimizelyInstance,
  experimentFlags,
  userContext,
  dispatch,
}: {
  optimizelyInstance: OptimizelyClientType;
  experimentFlags: string[];
  userContext: OptimizelyUserContext;
  dispatch: (action: unknown) => void;
}) {
  if (!experimentFlags || experimentFlags.length === 0 || !userContext) return null;

  const processedFlags = new Set<string>();
  const concatenatedKeys: string[] = [];
  const enabledValues: string[] = [];

  const listenerId = optimizelyInstance.notificationCenter.addNotificationListener(NOTIFICATION_TYPES.DECISION, (payload) => {
    const { decisionInfo } = payload as { decisionInfo: OptimizelyDecisionNotificationPayload };
    if (!decisionInfo) return;

    const { flagKey, ruleKey, variationKey, enabled } = decisionInfo;

    if (includes(experimentFlags, flagKey) && !processedFlags.has(flagKey)) {
      const concatenatedKey = [flagKey, variationKey, ruleKey].map(kebabCase).join('_');
      concatenatedKeys.push(concatenatedKey);
      enabledValues.push(enabled ? 'true' : 'false');
      processedFlags.add(flagKey);

      const allFlagsProcessed = processedFlags.size === experimentFlags.length;

      if (allFlagsProcessed) {
        const fxp_variant_string = concatenatedKeys.join(',');
        const enabled_string = enabledValues.join(',');
        const analyticsPayload: OptimizelyFeatureDecision = {
          fxp_variant_string,
          enabled_string,
        };

        dispatch(optimizelyFeatureDecision(analyticsPayload));
      }
    }
  });

  return listenerId;
}
